var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryGames(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8091 7.21252H11.9876C11.09 7.21252 10.3623 7.94041 10.3623 8.8383V10.3532C10.3623 11.2511 11.09 11.979 11.9876 11.979H17.8091C18.7068 11.979 19.4344 11.2511 19.4344 10.3532V8.8383C19.4344 7.94041 18.7068 7.21252 17.8091 7.21252Z",
    fill: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1753 11.979L41.9968 11.979C42.8944 11.979 43.6221 11.2511 43.6221 10.3532V8.8383C43.6221 7.94041 42.8944 7.21252 41.9968 7.21252L36.1753 7.21252C35.2776 7.21252 34.55 7.94041 34.55 8.8383V10.3532C34.55 11.2511 35.2776 11.979 36.1753 11.979Z",
    fill: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9847 22.0145V30.535C51.9847 33.2102 51.1721 35.8188 49.6576 38.021L48.1948 40.1419C47.6334 40.9695 46.8798 41.6199 46.0228 42.078C45.1659 42.5288 44.2054 42.7801 43.2007 42.7801C40.9253 42.7801 38.8272 41.5016 37.8003 39.4694L36.5665 37.0529C35.3476 34.6586 32.8875 33.1584 30.1983 33.1584H23.7858C21.1041 33.1584 18.644 34.6586 17.4176 37.0529L16.1839 39.4694C15.1496 41.5016 13.0662 42.7801 10.7908 42.7801C9.78611 42.7801 8.8183 42.5288 7.96133 42.078C7.10435 41.6199 6.35819 40.9695 5.78934 40.1419L4.34136 38.021C2.81949 35.8114 2.00684 33.188 2.00684 30.5055V22.0145C2.00684 16.4647 5.56772 11.7425 10.5323 10.0207C12.3866 9.37776 14.3813 9.2743 16.3242 9.54034L21.8059 10.2941C25.256 10.7671 28.7503 10.7671 32.2004 10.2941L37.6821 9.54034C39.6251 9.2743 41.6197 9.37037 43.4741 10.0207C48.4386 11.7499 51.9995 16.4647 51.9995 22.0145H51.9847Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.398 22.251V23.8989C19.398 24.4753 18.9252 24.9483 18.3489 24.9483H16.4577C15.8814 24.9483 15.4086 25.4212 15.4086 25.9976V27.8894C15.4086 28.4659 14.9358 28.9388 14.3596 28.9388H12.7121C12.1359 28.9388 11.6631 28.4659 11.6631 27.8894V25.9976C11.6631 25.4212 11.1902 24.9483 10.614 24.9483H8.73754C8.1613 24.9483 7.68848 24.4753 7.68848 23.8989V22.251C7.68848 21.6746 8.1613 21.2016 8.73754 21.2016H10.614C11.1902 21.2016 11.6631 20.7286 11.6631 20.1522V18.2604C11.6631 17.684 12.1359 17.2111 12.7121 17.2111H14.3596C14.9358 17.2111 15.4086 17.684 15.4086 18.2604V20.1522C15.4086 20.7286 15.8814 21.2016 16.4577 21.2016H18.3489C18.9252 21.2016 19.398 21.6746 19.398 22.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.456 24.9483C37.4883 24.9483 38.3251 24.1112 38.3251 23.0786C38.3251 22.0461 37.4883 21.209 36.456 21.209C35.4237 21.209 34.5869 22.0461 34.5869 23.0786C34.5869 24.1112 35.4237 24.9483 36.456 24.9483Z",
    fill: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4199 24.9483C45.4521 24.9483 46.289 24.1112 46.289 23.0786C46.289 22.0461 45.4521 21.209 44.4199 21.209C43.3876 21.209 42.5508 22.0461 42.5508 23.0786C42.5508 24.1112 43.3876 24.9483 44.4199 24.9483Z",
    fill: "#BA94D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4384 20.9579C41.4707 20.9579 42.3075 20.1208 42.3075 19.0882C42.3075 18.0556 41.4707 17.2186 40.4384 17.2186C39.4062 17.2186 38.5693 18.0556 38.5693 19.0882C38.5693 20.1208 39.4062 20.9579 40.4384 20.9579Z",
    fill: "#84BDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4384 28.9314C41.4707 28.9314 42.3075 28.0944 42.3075 27.0618C42.3075 26.0292 41.4707 25.1921 40.4384 25.1921C39.4062 25.1921 38.5693 26.0292 38.5693 27.0618C38.5693 28.0944 39.4062 28.9314 40.4384 28.9314Z",
    fill: "#82DBB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8082",
    x: 0.00683594,
    y: 5.21252,
    width: 53.9922,
    height: 39.5675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8082",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryGames);
export default __webpack_public_path__ + "static/media/category_games.21db184d699908e2e4117c17b58a6647.svg";
export { ForwardRef as ReactComponent };